import { useState, useEffect, useContext } from 'react'
import ContextStates from '../context/ContextStates';
import axios from 'axios';
import { Url } from './Url';
import { Link } from 'react-router-dom';


const FormJornadas = () => {
    const [jornada, setJornada] = useState([])
    const [totalCont, setTotalCont] = useState(0)
    const [totalTar, setTotalTar] = useState(0)
    const [totalCom, setTotalCom] = useState(0)
    const [totalTransf, setTotalTransf] = useState(0)
    const [totalEgresos, setTotalEgresos] = useState(0)
    const { estadoJornada, idUsuario, setFormView, setViewOpen, setVentaSelected, setEstadoJornada, setIdJornada } = useContext(ContextStates)

    useEffect(() => {
        const getJornada = async () => {
            const formData = new FormData()
            formData.append('idusuario', idUsuario);
            try {
                const results = await axios({
                    url: Url + 'api/getJornada.php',
                    method: 'POST',
                    data: formData,
                })
                //console.log(results)
                if (typeof results.data.results !== 'undefined') {
                    setJornada(results.data.results)
                    if (results.data.results.estado === '2') {
                        localStorage.removeItem("pvp_jnd")
                        setEstadoJornada(0)
                        localStorage.removeItem("pvp_st_jnd")
                        setIdJornada(0)
                    }
                }
                else {
                    localStorage.removeItem("pvp_jnd")
                    setEstadoJornada(0)
                    localStorage.removeItem("pvp_st_jnd")
                    setIdJornada(0)
                }

            } catch (e) {
                console.log(e)
            }
        }
        getJornada()
    }, [idUsuario])

    useEffect(() => {
        const calcTotal = () => {
            let tc = 0;
            let tt = 0;
            let tta = 0;
            let tcm = 0;
            let te = 0;
            if (typeof jornada !== 'undefined') {
                if (typeof jornada.ventas !== 'undefined') {
                    //console.log(jornada.ventas)
                    jornada.ventas.forEach(element => {                        
                        if (element.total) {
                            if (element.idmedio === '1') {
                                if (element.total && element.total!=='' && element.total!==0 && element.total!=='0' && element.total!=='NaN')
                                    tc = tc + parseInt(element.total);
                            }
                            else if (element.idmedio === '3') {
                                tta = tta + parseInt(element.total);
                            }
                            else if (element.idmedio === '4') {
                                tt = tt + parseInt(element.total);
                            }
                            else if (element.idmedio === '7') {
                                tcm = tcm + parseInt(element.total);
                            }
                        }
                    });
                    setTotalCont(tc)
                    setTotalTar(tta)
                    setTotalTransf(tt)
                    setTotalCom(tcm)
                }
                if (typeof jornada.compras !== 'undefined') {
                    jornada.compras.forEach(element => {
                        te = te + parseInt(element.total);
                    });
                    setTotalEgresos(te)
                }
            }
        }
        calcTotal()
    }, [jornada])

    const openJornada = () => {
        setFormView(50)
        setViewOpen(true)
    }

    const closeJornada = () => {
        setFormView(51)
        setViewOpen(true)
    }

    const handleView = (item) => {
        setVentaSelected(item)
        setFormView(7)
        setViewOpen(true)
    }

    return (
        <div className='flex flex-col min-h-screen justify-between'>
            <div className="transition-all w-full mt-3">
                <h2 className='text-center text-3xl'>Jornada de Caja</h2>
                <div className="w-full rounded-lg p-5 justify-center">
                    {estadoJornada === 0 ? (
                        <div className='w-1/3 sm:w-1/4 mx-auto'>
                            <button
                                type='button'
                                className="w-full flex shadow-md p-3 ml-3 bg-green-500 text-white hover:bg-green-400 transition-all uppercase font-bold rounded-lg"
                                onClick={() => openJornada()}
                            >
                                <p className='w-full text-center'>
                                    Abrir Jornada
                                </p>
                            </button>
                        </div>
                    ) : (
                        <div className='w-full'>
                            {typeof jornada !== 'undefined' && (
                                <div className='w-full mb-10 p-5 bg-slate-50 rounded-xl'>
                                    <p className='text-center text-xl'>Jornada Nº {jornada.numero}</p>
                                    <p className='text-center text-xl'>Hora de Apertura: {jornada.horaapertura}</p>
                                    <p className='text-center text-xl'>Monto inicial de Caja: ${jornada.montoinicial}</p>
                                </div>
                            )}
                            <div className='w-full flex justify-center'>
                                <div className='w-1/3 sm:w-1/4 mx-auto'>
                                    <Link to={"/"}>
                                        <button
                                            type='button'
                                            className="w-full flex shadow-md p-3 ml-3 bg-blue-600 text-white hover:bg-blue-400 transition-all uppercase font-bold rounded-lg"
                                        >
                                            <p className='w-full text-center'>
                                                Regresar a Ventas
                                            </p>
                                        </button>
                                    </Link>
                                </div>
                                <div className='w-1/3 sm:w-1/4 mx-auto'>
                                    <button
                                        type='button'
                                        className="w-full flex shadow-md p-3 ml-3 bg-orange-500 text-white hover:bg-orange-400 transition-all uppercase font-bold rounded-lg"
                                        onClick={() => closeJornada()}
                                    >
                                        <p className='w-full text-center'>
                                            Cerrar Jornada
                                        </p>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="w-full sm:w-10/12 mx-auto py-5 px-2">
                    {typeof jornada !== 'undefined' && typeof jornada.ventas !== 'undefined' && (
                        <div className='w-full'>
                            <h3 className='text-center text-2xl uppercase'>Ingesos</h3>
                            <table className='w-full mx-auto'>
                                <thead>
                                    <tr className='p-1 bg-blue-400 text-white text-center'>
                                        <th>Nº</th>
                                        <th>Fecha</th>
                                        <th>Hora</th>
                                        <th>Total</th>
                                        <th>Márgen ganancia</th>
                                        <th>Medio de Pago</th>
                                        <th>Tipo de Venta</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        jornada.ventas.map((item, index) => (
                                            <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-100 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                                <td>{item.numerocomprobante}</td>
                                                <td>{item.fecha}</td>
                                                <td>{item.hora}</td>
                                                <td>$ {item.total}</td>
                                                <td>$ {item.margen}</td>
                                                <td>{item.medio}</td>
                                                <td>{item.tipo === '0' ? 'Venta local' : 'Envío'}</td>
                                                <td className='text-center'>
                                                    <button className='bg-blue-600 hover:bg-blue-400 rounded-lg py-1 px-3 text-white' onClick={() => handleView(item)}>Ver</button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    <tr className='border border-gray-100 p-2 text-right font-bold bg-blue-100'>
                                        <td colSpan={3} className='text-left'>Total de Contado</td>
                                        <td colSpan={5} className='text-left'>$ {parseFloat(totalCont).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    </tr>
                                    <tr className='border border-gray-100 p-2 text-right font-bold bg-white'>
                                        <td colSpan={3} className='text-left'>Total con Tarjeta de crédito</td>
                                        <td colSpan={5} className='text-left'>$ {parseFloat(totalTar).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    </tr>
                                    <tr className='border border-gray-100 p-2 text-right font-bold bg-blue-100'>
                                        <td colSpan={3} className='text-left'>Total con Transferencia</td>
                                        <td colSpan={5} className='text-left'>$ {parseFloat(totalTransf).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    </tr>
                                    <tr className='border border-gray-100 p-2 text-right font-bold bg-white'>
                                        <td colSpan={3} className='text-left'>Total usando 2 medios de pago</td>
                                        <td colSpan={5} className='text-left'>$ {parseFloat(totalCom).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
                <div className="w-full sm:w-10/12 mx-auto py-5 px-2">
                    {typeof jornada !== 'undefined' && typeof jornada.compras !== 'undefined' && (
                        <div className='w-full'>
                            <h3 className='text-center text-2xl uppercase'>Egresos</h3>
                            <table className='w-full mx-auto'>
                                <thead>
                                    <tr className='p-1 bg-blue-400 text-white text-center'>
                                        <th>Fecha</th>
                                        <th>Hora</th>
                                        <th>Total</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        jornada.compras.map((item, index) => (
                                            <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                                <td>{item.fecha}</td>
                                                <td>{item.hora}</td>
                                                <td>$ {item.total}</td>
                                                <td className='text-center'>
                                                    <button className='bg-blue-600 hover:bg-blue-400 rounded-lg py-1 px-3 text-white' onClick={() => handleView(item)}>Ver</button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    <tr className='border border-gray-300 p-2 text-center font-bold bg-orange-200'>
                                        <td>Total de Egresos</td>
                                        <td></td>
                                        <td>$ {parseFloat(totalEgresos).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default FormJornadas